export const student_living = {
    meta_title: "Student Living Fiber Networks | GPON Connectivity Solutions",
    meta_description:
        "Niurix GPON solutions deliver reliable fiber connectivity to student living environments with simplified network management.",

    section1: {
        banner_img: "Student Living Banner",
        banner_img_mobile: "Student banner",
        title: "Fiber Optic Solutions for Learning: Get the Speed You Need to Succeed.",
    },
    section2: {
        img: "STUDENT LIVING1",
        title: "A network that fits all - <span>Redesigning the future of learning</span>",
        subtitle: "Lorem_Subtitle",
        desc: "Fast and reliable internet network is a need for modern day student living setting not only for learning but for entertainment. Introducing Niurix as a fiber optic solution, offering triple play services to every room without a mesh of wires to create a single network.",
    },

    section3: [
        {
            device_img: "ISP Router",
            device_title: "Router",
        },

        {
            device_img: "olt",
            device_title: "OLT",
        },

        {
            device_img: "Splitter",
            device_title: "Splitter",
        },

        {
            device_img: "Internet traffic",
            device_title: "Internet traffic",
        },

        {
            device_img: "1G Fiber",
            device_title: "1G Fiber",
        },

        {
            device_img: "Ethernet cable",
            device_title: "Ethernet cable",
        },

        {
            device_img: "ONT",
            device_title: "ONT",
        },

        {
            device_img: "IPTV",
            device_title: "IPTV",
        },

        {
            device_img: "Router",
            device_title: "Access Point",
        },

        {
            device_img: "telephone",
            device_title: "telephone",
        },

        {
            device_img: "wireless",
            device_title: "Wireless",
        },
    ],
    section4: {
        title: "Advantages of Niurix Student Living Solutions",
        desc: "Modern learning requires high-speed, reliable internet. Harness uninterrupted and secure connection of FTTR (Fiber to the Room) student living solution from Niurix to unlock productivity without any delays.",
        cards: [
            {
                cards_img: "Reliable-Connectivity",
                cards_title: "Reliable Connectivity",
                // cards_desc: "Access an extensive range of the latest generation in wireless connectivity along with wired connectivity solutions.",
            },

            {
                cards_img: "Advanced-Network-Security",
                cards_title: "Advanced Network Security",
                // cards_desc: "Experience more secure connectivity with fiber optics and prevent student's sensitive data.",
            },

            {
                cards_img: "Differentiate Competitively",
                cards_title: "Differentiate Competitively",
                // cards_desc: "Offering students a unique and fast network solution sets student living communities apart from competitors.",
            },

            {
                cards_img: "Easy-Maintenance",
                cards_title: "Easy Maintenance",
                // cards_desc: "Hassle-free functioning for smooth operations without easy corrosion and minimum signal loss issues.",
            },
        ],
    },
    section5: {
        img: "contact banner",
        title: "Lorem",
    },
};
